import { PopoverButton } from '@headlessui/react';
import { FunnelIcon } from '@heroicons/react/24/solid';
import React from 'react';

const FilterButton: React.FC = () => {
  return (
    <PopoverButton
      data-collapse-toggle="mobile-filter"
      type="button"
      className="ml-1 flex rounded-lg bg-gray-100 p-2 text-sm text-gray-500 ring-2 ring-teal-500 focus:outline-none dark:bg-gray-700 dark:text-gray-400 dark:ring-teal-200 dark:focus:ring-teal-600"
      aria-controls="mobile-filter"
      aria-expanded="false"
    >
      <span className="sr-only">Открыть фильтр</span>
      <FunnelIcon className="h-5 w-5 text-teal-500 dark:text-teal-200" />
    </PopoverButton>
  );
};

export default FilterButton;
